<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div class="row mb-3">
                        <div class="col-sm-12 col-md-6">
                                <input
                  type="search"
                  class="
                    form-control
                    ml-0
                    shadow-inset-1
                  "
                  :placeholder="$t('label.search')"
                  v-model="searchMember"
                  @input="searchMemberList"
                />
            </div>
            <div class="col-sm-12 col-md-6">
                <date-range-picker class="w-100 mb-2"
                    ref="picker"
                    v-model="dateRange"
                    :opens="'right'"
                    :autoApply="true"
                    :showDropdowns="true" 
                    :always-show-calendars="false"
                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                    @showCustomRange="showCustomRangeCalendars=true"
                    @update="filterByDate">
                </date-range-picker>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
export default {
    name: "voucherFilter",
    components:{
        DateRangePicker
    },
    data(){
        let now = moment();
        let startDate = now.startOf('month').toDate();
        let endDate = now.endOf('month').toDate()
        return{
            tab: "summary",
            selectedDateFilter: "all", 
            selectedType: "all",
            dateRange: { startDate, endDate },
            exportHeaders: [], exportFields: {}, exportData: [], exportFileName: "",
            searchMember:""
        }
    },
    watch:{
        selectedDateFilter(value){
            if(value == "all"){
                this.filterVoucherItem();
            }
        },
        "$i18n.locale"(val){
            this.staff[0].text = this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})
            
            var b = Object.assign({}, this.selectedStaff)
            this.selectedStaff = this.staff.filter(obj=> obj.id == b.id)[0]
        }
    },
    methods:{
        searchMemberList(){
            this.$emit("search",this.searchMember);
        },
        clearFilter(){
            let now = moment();
            let startDate = now.startOf('day').toDate();
            let endDate = now.endOf('day').toDate()
            this.dateRange = {startDate, endDate}

            this.selectedDateFilter = this.selectedType = "all"
            this.selectedOutlet = this.outlet[0]
            this.selectedStaff = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})}

            this.filterVoucherItem();
        },
        filterByDate(date){
            var endDate = moment(date.endDate)
            var mEndDate = endDate.endOf('day').toDate()
            this.dateRange = {startDate: date.startDate, endDate: mEndDate}
            this.filterVoucherItem();
        },

        filterVoucherItem(){
            var data = {
                dateType: this.selectedDateFilter,
                date: this.dateRange,
            }
            this.$emit('filterVoucherItem', data)
        },
        setExportData(data){
            this.exportData = data.data
            this.exportFields = data.fields
            this.exportHeaders = data.headers
            this.exportFileName = data.fileName
        },
    },
    mounted(){
        let $vm = this;
        $vm.filterVoucherItem()
    }
}
</script>
<style scoped>
.link, .nav-link{
    cursor: pointer;
}
</style>